<template>
  <div class="!pt-2">
    <el-form label-position="right">
      <div class="form-group" style="display: flex; justify-content: center">
        <!-- {{field}} -->
        <div class="flex flex-col items-start justify-center gap-2 w-full">
          <span class="">
            <label
              class="field-title-label !text-black-600 !text-xs 2xl:!text-sm !font-normal block !mb-1"
              for=""
            >
              Authorized Signature
            </label>
          </span>
          <el-select
            class="w-full"
            v-model="field.authorized_signature"
            :default-first-option="true"
            :filterable="true"
            :no-data-text="'Authorized Signature'"
          >
            <el-option
              v-for="(signature, index) of authorizedSignatures"
              :key="index"
              :label="signature.name"
              :value="signature._id"
              :aria-selected="index == 0 ? true : false"
            >
              <span style="float: left">{{ signature.name }}</span>
              <span style="float: right; color: #8492a6; font-size: 13px">
                {{ signature.designation }}
              </span>
            </el-option>
          </el-select>
        </div>
      </div>
    </el-form>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';
  export default {
    name: 'templates-formComponents-AuthorizedSignature',
    components: {},
    computed: {
      ...mapGetters('company', ['getAuthorizedSignatures']),
      authorizedSignatures() {
        return this.getAuthorizedSignatures || [];
      },
      selectedValueData() {
        return (this.getAuthorizedSignatures || []).find(
          (signature) => signature._id == this.field.authorized_signature
        );
      },
    },
    props: ['field'],
    data() {
      return {};
    },
    mounted() {
      this.fetchAuthorizedSignature();
    },
    methods: {
      async fetchAuthorizedSignature() {
        await this.$store.dispatch('company/getCompanyAuthorizationSignatures', {
          get_all: true,
        });
      },
      setSelectedValue(data) {
        console.log({ data });
      },
    },
  };
</script>

<style lang="scss"></style>
